import { getApiBaseUrl } from "../../../config/api";

export function getDocumentUrl(docPath: string): string {
  const base = getApiBaseUrl().replace(/\/$/, "");
  const cleanPath = (docPath || "").replace(/^\//, "");
  return base && cleanPath ? `${base}/${cleanPath}` : "";
}

export function extractDownloadInfoUrl(
  data: { download_info?: unknown } | null | undefined
): string | null {
  const raw = data?.download_info;
  if (typeof raw === "string" && raw.trim()) {
    const s = raw.trim();
    if (/^https?:\/\//i.test(s)) return s;
    try {
      const parsed = JSON.parse(s) as { url?: string; download_url?: string };
      if (typeof parsed?.url === "string" && parsed.url) return parsed.url;
      if (typeof parsed?.download_url === "string" && parsed.download_url)
        return parsed.download_url;
    } catch {
      return s;
    }
  }
  if (raw && typeof raw === "object") {
    const o = raw as { url?: unknown; download_url?: unknown };
    if (typeof o.url === "string") return o.url;
    if (typeof o.download_url === "string") return o.download_url;
  }
  return null;
}
